/**
 * 广告加载模块
 */

import bdwm from './ad/ad_bdwm';
import ad360 from './ad/ad_360';

export default {
  /**
   * 广告请求分发
   * @param adType
   * @param param
   */
  getAdsList (adType, param) {
    switch (adType) {
      case 'bdwm':
        bdwm.getAdsList(param, arguments[2]);
        break;
      case '360':
        ad360.getAdsList(param, arguments[2]);
        break;
      default:
        console.log('ad getAdList err', ...arguments);
        break;
    }
  }
}
